interface SectionHeadProps {
  index: string;
  kicker: string;
  title: string;
  desc?: string;
  action?: string;
}

export default function SectionHead({ index, kicker, title, desc, action }: SectionHeadProps) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div className="max-w-2xl">
        <div className="flex items-center gap-3">
          <span className="font-heading text-sm font-black tracking-wide text-primary-500">{index}</span>
          <span className="text-xs font-bold uppercase tracking-[0.18em] text-accent-700">{kicker}</span>
        </div>
        <h2 className="editorial-title mt-2 text-2xl font-black leading-snug text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {desc ? <p className="mt-3 text-sm leading-relaxed text-foreground-600">{desc}</p> : null}
      </div>
      {action ? (
        <a
          href="#hot"
          className="group inline-flex shrink-0 cursor-pointer items-center gap-1.5 whitespace-nowrap text-sm font-bold text-primary-600 hover:text-primary-700"
        >
          {action}
          <i className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-0.5" />
        </a>
      ) : null}
    </div>
  );
}